import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import QRCode from "qrcode.react";
import { Button } from "reactstrap";

const PresentingSlidekick = (props) => {
  let link = _.get(props, "gameReducer.roomObj.branch_url");
  let roomData = _.get(props, "gameReducer.roomObj");
  const param = _.get(props, "paramsReducer.gameObj.joining");
  let joinCode = _.get(roomData, "join_code");

  let joinCodeText = param.join_code_bottom;
  let scanTextTop = param.scan_top;
  let scanTextBottom = param.scan_bottom;

  return (
    <div className="join-now-container">
      <div className="l-8 h-100 text-center joinNow">
        <div className="flex-grow-1 d-flex flex-column">
          <p className="scan-text-top">
            <b>{scanTextTop}</b>
          </p>
          <div className="qrWrapper">
            <QRCode
              value={link && link !== "" ? link : "Loading"}
              size={400}
              bgColor="transparent"
              fgColor={"#2A2A2A"}
            />
          </div>
          <h4 className="text scan-text">{scanTextBottom}</h4>
        </div>
        <div>
          <p className="text textLine">OR</p>
          <p className="text">
            <b>{joinCodeText}</b>
          </p>
          <button className="w-100 btn">
            {link && link !== "" ? joinCode : "Loading"}
          </button>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = () => {
  return {};
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(
  PresentingSlidekick
);
